import { useSelector } from 'react-redux';
import {
  defaultFeaturesSelector,
  qaFeaturesSelector,
  regionalFeaturesSelector,
  tokenFeaturesSelector,
} from '@xarvio/frontend-core-state/lib/featureFlags/selectors';
import { getIsFeatureVisible } from '@xarvio/frontend-core-state/lib/featureFlags/utils';

export const useGetIsCountryEnabledToLogin = () => {
  const defaultFeatures = useSelector(defaultFeaturesSelector);
  const regionalFeatures = useSelector(regionalFeaturesSelector);
  const tokenFeatures = useSelector(tokenFeaturesSelector);
  const qaFeatures = useSelector(qaFeaturesSelector);

  return (countryCode: string) => {
    return getIsFeatureVisible({
      countryCode,
      featureName: 'USER_LOGIN',
      defaultFeatures,
      regionalFeatures,
      tokenFeatures,
      qaFeatures,
    });
  };
};
